<template>
    <div class="list__wrap field-wrap">
        <draggable
            draggable=".list__item"
            handle=".draggableHandle"
            animation="150"
            :tag="'ul'"
            @end="dragEnd"
            class="list"
        >
            <li
                class="list__item"
                v-for="(items__value, items__key) in items"
                v-bind:key="items__value.id"
                v-bind:class="showIndividualColored && !items__value.preset_id ? 'individual' : ''"
                :data-id="items__value.id"
            >
                <ul class="list__details">
                    <li class="list__visibility">
                        <app-checkbox
                            v-if="showHide(items__value.id)"
                            :data-source="dataSource + '.' + items__value.id + '.visible'"
                        ></app-checkbox>
                    </li>
                    <li
                        class="list__content"
                        v-html="getItemContent(items__value, items__key)"
                    ></li>
                    <li class="list__edit">
                        <a
                            v-on:click.prevent="edit(items__value.id)"
                            v-if="listSubpage && (!editOnlyIndividual || !items__value.preset_id)"
                            href="#"
                            class="list__edit-icon"
                            >Bearbeiten</a
                        >
                    </li>
                    <li class="list__handle">
                        <span class="draggableHandle list__handle-element">Verschieben</span>
                    </li>
                </ul>
            </li>
        </draggable>

        <div v-if="allowIndividual === true && hideAddButton !== true">
            <div class="list__add">
                <a
                    v-on:click.prevent="add"
                    href="#"
                    class="button button--icon-plus-text"
                    v-html="label ? label + ' hinzufügen' : 'hinzufügen'"
                    >neu hinzufügen</a
                >
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import { mapGetters, mapActions } from 'vuex';
import { ComplexFieldMixin } from '@/mixins/ComplexFieldMixin';
import Text from '@/components/fields/simple/Text.vue';
import Checkbox from '@/components/fields/simple/Checkbox.vue';
import Hidden from '@/components/fields/simple/Hidden.vue';
import { toArray } from '@/helpers/utils';

export default {
    data() {
        return {
            alreadyInited: false
        };
    },
    components: {
        'app-text': Text,
        'app-checkbox': Checkbox,
        'app-hidden': Hidden,
        draggable
    },
    methods: {
        ...mapActions(['setProp', 'initOrUpdateList', 'createListItem', 'routeAddQuery']),
        /* init */
        async init() {
            // because initOrUpdateList is quite heavy, we only do this once per component creation
            if (this.alreadyInited === false) {
                this.alreadyInited = true;
                await this.initOrUpdateList({
                    dataSource: this.dataSource,
                    dataPreset: this.dataPreset
                });
            }
        },
        /* validate */
        validate() {
            return true;
        },
        /* custom setters */
        async add() {
            await this.createListItem({
                dataSource: this.dataSource,
                listSubpage: this.listSubpage
            });
        },
        async edit(id) {
            await this.routeAddQuery({
                listeditor: 1,
                listeditor_subpage: this.listSubpage,
                listeditor_source: this.dataSource,
                listitem_id: id
            });
        },
        async dragEnd(e) {
            await this.setPosForListItem({
                id: e.item.getAttribute('data-id'),
                module_id: this.getActiveModuleId,
                source: this.dataSource,
                pos: e.newIndex + 1 + (e.newIndex > e.oldIndex ? 0.1 : -0.1)
            });
        },
        async setPosForListItem(payload) {
            await this.addDifferChangedField({
                source: this.dataSource + '.' + payload.id + '.pos',
                value: this.getProp(this.dataSource + '.' + payload.id + '.pos'),
                route: this.openedRoute
            });
            await this.setProp({
                source: this.dataSource + '.' + payload.id + '.pos',
                value: payload.pos
            });
            await this.reindexListItemPositions({
                source: payload.source
            });
        },
        async reindexListItemPositions(payload) {
            let listitems = toArray(this.getProp(this.dataSource))
                    .filter((i) => i.source === undefined || i.source === payload.source)
                    .sort((a, b) => a.pos - b.pos),
                posCur = 1;
            if (this.dataConditions !== undefined) {
                Object.entries(this.dataConditions).forEach(
                    ([conditions__key, conditions__value]) => {
                        listitems = listitems.filter(
                            (i) => i[conditions__key] === conditions__value
                        );
                    }
                );
            }
            for (let listitems__value of listitems) {
                await this.addDifferChangedField({
                    source: this.dataSource + '.' + listitems__value.id + '.pos',
                    value: listitems__value.pos,
                    route: this.openedRoute
                });
                await this.setProp({
                    source: this.dataSource + '.' + listitems__value.id + '.pos',
                    value: posCur
                });
                posCur++;
            }
        },
        showHide(id) {
            if (this.getActiveMenuId) {
                return this.isPageHidable(id);
            }
            return true;
        },
        getItemContent(item_value, item_key) {
            let data = '';
            if (this.getProp(this.dataSource + '.' + item_value.id + '.' + this.dataName)) {
                data = this.getProp(this.dataSource + '.' + item_value.id + '.' + this.dataName);
                return data;
            }
            if (
                this.dataFlexible &&
                this.getProp(this.dataSource + '.' + item_value.id + '.' + this.dataSubtitle)
            ) {
                data = this.getProp(
                    this.dataSource + '.' + item_value.id + '.' + this.dataSubtitle
                );
                return data;
            }
            if (
                this.dataFlexible &&
                this.getProp(this.dataSource + '.' + item_value.id + '.' + this.dataText)
            ) {
                data = this.getProp(this.dataSource + '.' + item_value.id + '.' + this.dataText);
                return data;
            }
            if (this.listLabel) {
                data = this.listLabel + ' ' + (item_key + 1);
            }
            return data;
        }
    },
    computed: {
        ...mapGetters([
            'getProp',
            'getActiveModuleId',
            'getActiveMenuId',
            'getActiveConfiguratorGroup',
            'getListItems',
            'isPageHidable'
        ]),
        items() {
            return this.getListItems(this.dataSource, true, this.dataConditions);
        }
    },
    props: {
        dataSource: String,
        dataConditions: Object,
        dataPreset: [String, Boolean],
        dataName: String,
        dataSubtitle: String,
        dataText: String,
        dataFlexible: Boolean,
        listLabel: String,
        allowIndividual: Boolean,
        listSubpage: [String, Boolean],
        label: String,
        hideAddButton: Boolean,
        editOnlyIndividual: Boolean,
        showIndividualColored: Boolean
    },
    mixins: [ComplexFieldMixin]
};
</script>
